// inputs.js
import { validateInteger, validateRequired, validateLength, validateNonZeroInteger, validateEmail, validateNotNull } from "../../../../helpers/validationsForm";

const Inputs = [
  {
    id: 1,
    label: "Nombre",
    name: "sel_firstname",
    type: "text",
    placeholder: "Ingrese el nombre",
    validation: (value, form) => {
      // Validación requerida
      const requiredError = validateRequired(value);
      if (requiredError) {
        return requiredError;
      }

      // Validación de longitud
      const lengthError = validateLength(value, { minLength: 3, maxLength: 40 });
      if (lengthError) {
        return lengthError;
      }

      // Si no hay errores
      return null;
    }
  },
  {
    id: 2,
    label: "Apellido",
    name: "sel_lastname",
    type: "text",
    placeholder: "Ingrese el apellido",
    validation: (value, form) => {
      // Validación requerida
      const requiredError = validateRequired(value);
      if (requiredError) {
        return requiredError;
      }

      // Validación de longitud
      const lengthError = validateLength(value, { minLength: 3, maxLength: 40 });
      if (lengthError) {
        return lengthError;
      }

      // Si no hay errores
      return null;
    }
  },
  {
    id: 3,
    label: "Mail",
    name: "sel_mail",
    type: "text",
    placeholder: "Ingrese su email",
    validation: (value, form) => {
      // Validación de correo
      const emailError = validateEmail(value);
      if (emailError) {
        return emailError;
      }

      // Validación de longitud
      const lengthError = validateLength(value, { minLength: 2, maxLength: 59 });
      if (lengthError) {
        return lengthError;
      }

      // Si no hay errores
      return null;
    }
  },

  {
    id: 4,
    label: "Rol",
    name: "rol_id",
    type: "select",
    value: "",
    options: [],
    validation: (value, form) => {
      // Validación requerida
      const requiredError = validateNotNull(value);
      if (requiredError) {
        return requiredError;
      }

      // Validación de longitud
      const lengthError = validateNonZeroInteger(value);
      if (lengthError) {
        return lengthError;
      }

      // Si no hay errores
      return null;
    }
  },
  {
    id: 5,
    label: "Usuario (Web)",
    name: "sel_username",
    type: "text",
    placeholder: "Minimo 6 caracteres",
    validation: (value, form) => {
      // Validación de longitud
      const lengthError = validateLength(value, { minLength: 6, maxLength: 10 });
      if (lengthError) {
        return lengthError;
      }

      // Si no hay errores
      return null;
    }
  },
  {
    id: 6,
    label: "Contraseña (Web)",
    name: "pass_web",
    type: "text",
    placeholder: "Minimo 6 caracteres  May/min/Num",
    validation: (value, form) => {
      // Validación de longitud
      const lengthError = validateLength(value, { minLength: 6, maxLength: 10 });
      if (lengthError) {
        return lengthError;
      }

      // Si no hay errores
      return null;
    }
  },

  {
    id: 7,
    label: "Usuario (Movil)",
    name: "sel_user_app",
    type: "text",
    placeholder: "Minimo 6 caracteres",
    validation: (value, form) => {
      // Validación de longitud
      const lengthError = validateLength(value, { minLength: 6, maxLength: 10 });
      if (lengthError) {
        return lengthError;
      }

      // Si no hay errores
      return null;
    }
  },
  {
    id: 8,
    label: "Contraseña (Movil)",
    name: "pass_app",
    type: "text",
    placeholder: "Minimo 6 caracteres  May/min/Num",
    validation: (value, form) => {
      // Validación de longitud
      const lengthError = validateLength(value, { minLength: 6, maxLength: 10 });
      if (lengthError) {
        return lengthError;
      }

      // Si no hay errores
      return null;
    }
  },
  {
    id: 9,
    label: "Sucursal",
    name: "suc_id",
    type: "select",
    validation: (value, form) => {
      // Validación de longitud
      const integerError = validateInteger(value);
      if (integerError) {
        return integerError;
      }

      // Si no hay errores
      return null;
    }
  },
  {
    id: 10,
    label: "Deposito",
    name: "depo_id",
    type: "select",
    validation: (value, form) => {
      // Validación de longitud
      const integerError = validateInteger(value);
      if (integerError) {
        return integerError;
      }

      // Si no hay errores
      return null;
    }
  }, {
  id: 11,
  label: "Requerir GPS para enviar pedido",
  name: "sel_allow_ocgps",
  type: "select",
  defaultValue: 0, // O bien 1, dependiendo del valor predeterminado
  options: [
    { value: 1, label: 'Si' },
    { value: 0, label: 'No' },
  ],
  placeholder: "Ingrese el requerimiento de GPS",
}


];

export default Inputs;
